<template>
  <div class="flex flex-col min-h-screen pb-0">
    <!-- Intro Modal -->
    <IntroModal v-model="showIntroModal" />

    <!-- Sign In Modal -->
    <div
      v-if="store.showSignInModal"
      class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 px-4"
    >
      <div class="bg-white rounded-lg shadow-xl max-w-md w-full p-0 relative overflow-hidden mx-auto">
        <div class="relative">
          <button
            @click="store.showSignInModal = false"
            class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 z-10"
          >
            ✕
          </button>
          <SignInView />
        </div>
      </div>
    </div>

    <!-- Desktop Navigation -->
    <nav class="hidden md:block bg-white shadow-sm">
      <div class="max-w-screen-sm mx-auto px-4 h-16">
        <div class="flex items-center justify-between h-full">
          <div class="flex space-x-8">
            <router-link
              v-for="(item, index) in navItems" 
              :key="index"
              :to="item.to"
              class="flex items-center px-3 py-2 text-gray-700 hover:text-green-600 transition-colors"
              :class="{ 'text-green-600': $route.path === item.to }"
            >
              <span class="material-icons-outlined text-xl mb-1">{{ item.icon }}</span>
              {{ item.text }}
              <span v-if="item.badge && item.badge.value > 0" class="ml-1 px-1.5 py-0.5 bg-red-500 text-white text-xs rounded-full">
                {{ item.badge.value }}
              </span>
            </router-link>
          </div>
          <div class="flex space-x-4"></div>
        </div>
      </div>
    </nav>

    <!-- Main Content -->
    <main class="min-h-screen pb-16 md:pb-0 pt-4">
      <div class="max-w-screen-sm mx-auto">
        <!-- Test button to open modal (remove or move as needed) -->
        <!-- <button
          @click="store.showSignInModal = true"
          class="mb-4 px-4 py-2 bg-blue-600 text-white rounded"
        >
          Open Sign In Modal
        </button> -->
        <!-- Login state: {{ store.isAuthenticated }} -->
        <router-view />
      </div>
    </main>

    <!-- Mobile Navigation -->
    <nav class="fixed left-0 right-0 bottom-0 z-50 md:hidden bg-white shadow-lg border-t border-gray-100">
      <div class="grid grid-cols-4 h-12">
        <router-link
          v-for="(item, index) in navItems" 
          :key="index"
          :to="item.to"
          class="flex flex-col items-center justify-center text-gray-700 hover:text-green-600 transition-colors relative"
          :class="{ 'text-green-600': $route.path === item.to }"
        >
          <span class="material-icons-outlined text-xl mb-1">{{ item.icon }}</span>
          <span v-if="item.badge && item.badge.value > 0" class="absolute top-0 left-1/2 translate-x-1 px-1.5 py-0.5 bg-red-500 text-white text-xs rounded-full min-w-[18px] text-center">
            {{ item.badge.value }}
          </span>
        </router-link>
      </div>
    </nav>

    <!-- Global Notification Toast -->
    <NotificationToast />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { auth } from './auth/auth';
import { geo } from './geo/geo';
import SignInView from './views/SignInView.vue';
import IntroModal from './components/IntroModal.vue';
import NotificationToast from './components/NotificationToast.vue';
import { store } from './stores/userStore';  // Import the store
import { useUnreadMessages } from './composables/useUnreadMessages';


const showIntroModal = ref(false);
const locationAllowed = ref(false);
const router = useRouter();

const { unreadCount, startPolling, stopPolling } = useUnreadMessages();

async function checkLocation() {
  // Use the async hasAllowedLocation method from auth
  
  const allowed = await auth.hasAllowedLocation?.() ?? false;
  console.log('Location allowed:', allowed);
  locationAllowed.value = !!allowed;
  geo.getLocation();

}

onMounted(async () => {
//store.isAuthenticated = auth.isAuthenticated(); // just do this once on mount of app

  //await checkLocation();
  if (!localStorage.getItem('charmed_intro_seen')) {
    //showIntroModal.value = true;
  }
  auth.handleRedirect();
  
  // Start polling for unread messages
  startPolling();
});

onUnmounted(() => {
  stopPolling();
});

const navItems = [
  { to: '/', icon: 'travel_explore', text: 'Nearby' },
  // { to: '/cart', icon: 'shopping_bag', text: 'Cart' },
  { to: '/wallet', icon: 'style', text: 'Rewards' },
  { to: '/messages', icon: 'chat', text: 'Messages', badge: unreadCount },
  { to: '/settings', icon: 'menu', text: 'Settings' }
];
</script>

<style>
@import url('https://fonts.googleapis.com/icon?family=Material+Icons+Outlined');

:root {
  --card-height: 400px;
  --card-width: 280px;
}

body {
  @apply antialiased text-gray-800 bg-gray-50;
}

/* Ensure main content does not hide behind the fixed nav */
main {
  padding-bottom: 3.5rem !important; /* 56px = h-12 */
}
</style>